import { render, staticRenderFns } from "./lottery.vue?vue&type=template&id=cd38bb40&scoped=true&"
import script from "./lottery.vue?vue&type=script&lang=js&"
export * from "./lottery.vue?vue&type=script&lang=js&"
import style0 from "./lottery.vue?vue&type=style&index=0&id=cd38bb40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd38bb40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd38bb40')) {
      api.createRecord('cd38bb40', component.options)
    } else {
      api.reload('cd38bb40', component.options)
    }
    module.hot.accept("./lottery.vue?vue&type=template&id=cd38bb40&scoped=true&", function () {
      api.rerender('cd38bb40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/lottery.vue"
export default component.exports